var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _vm.checkPromoLoading
        ? _c(
            "v-card",
            {
              attrs: {
                flat: ""
              }
            },
            [
              _c(
                "v-card-text",
                [
                  _c("v-progress-circular", {
                    attrs: {
                      size: "64",
                      color: "primary",
                      indeterminate: ""
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _c(
            "div",
            [
              !_vm.servicesUnavailable
                ? _c(
                    "div",
                    [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            {
                              attrs: {
                                cols: "12"
                              }
                            },
                            [
                              _c(
                                "v-sheet",
                                [
                                  _c("v-card-text", [
                                    _c("h2", [_vm._v(_vm._s(_vm.promo.name))]),
                                    _c("p", [
                                      _vm._v(_vm._s(_vm.promo.description))
                                    ])
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            {
                              attrs: {
                                cols: "12"
                              }
                            },
                            [
                              _c(
                                "v-sheet",
                                [
                                  _c(
                                    "v-card-text",
                                    [
                                      _c("h3", [_vm._v("Select Service")]),
                                      _c("p", [
                                        _vm._v(
                                          "The following services are eligible for this promotion. Please select a service."
                                        )
                                      ]),
                                      _c("p", [
                                        _vm._v(
                                          "Promotion details will be confirmed on the next step."
                                        )
                                      ]),
                                      _c(
                                        "v-card-text",
                                        [
                                          _c(
                                            "v-form",
                                            [
                                              _c("v-autocomplete", {
                                                directives: [
                                                  {
                                                    name: "validate",
                                                    rawName: "v-validate",
                                                    value: "required",
                                                    expression: "'required'"
                                                  }
                                                ],
                                                attrs: {
                                                  loading: !_vm.promoServicesPopulated,
                                                  items: _vm.eligibleServices,
                                                  "item-text": "fullName",
                                                  label: "Select a service",
                                                  "error-messages": _vm.errors.collect(
                                                    "service"
                                                  ),
                                                  "data-vv-as": "Service",
                                                  "data-vv-name": "service",
                                                  outlined: "",
                                                  "return-object": ""
                                                },
                                                model: {
                                                  value: _vm.selectedService,
                                                  callback: function callback(
                                                    $$v
                                                  ) {
                                                    _vm.selectedService = $$v
                                                  },
                                                  expression: "selectedService"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-card-actions",
                                        [
                                          _c(
                                            "gg-btn",
                                            {
                                              attrs: {
                                                color: "primary",
                                                tile: "",
                                                elevation: "0"
                                              },
                                              on: {
                                                click: _vm.nextStep
                                              }
                                            },
                                            [_vm._v("Next")]
                                          ),
                                          _c(
                                            "gg-btn",
                                            {
                                              attrs: {
                                                tile: "",
                                                elevation: "0"
                                              }
                                            },
                                            [_vm._v("Cancel")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _c("v-sheet", [_vm._v(" " + _vm._s(_vm.noServiceMsg) + " ")])
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }